import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import CustomRadio from 'components/custom-radio';
import { propsToJS } from '__utils/immutable-to-js';
import NFOSelector from './nfo.selector';
import { useSelector, useDispatch } from 'react-redux';
import { setNFOappliedSortOption } from './nfo.actions';
import resetIcon from '../../images/resetIcon.svg';
import closeIcon from '../../images/closeIcon.svg';

const PopupCont = styled.div`
    display: block;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    outline: 0;
    transition: opacity .15s linear;
    background: rgba(100, 100, 100, 0.5);
`;

const VerticleAlignedCont = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    -moz-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 100%;
    &.mediaPopup {
        position: fixed;
        top: auto;
        bottom: 0;
        transform: none;
        left: 0;
    }
`;

const ModalOuterCont = styled.div`
    position: relative;
    width: 80%;
    margin: 0 auto;
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-animation-name: zommingEffect;
    -webkit-animation-duration: .3s;
    animation-name: zommingEffect;
    animation-duration: .3s;
    -webkit-transition: -webkit-transform .3s ease-out;
    -o-transition: -o-transform .3s ease-out;
    transition: transform .3s ease-out;

    -webkit-transform: translate(0,-25%);
    -ms-transform: translate(0,-25%);
    -o-transform: translate(0,-25%);
    transform: translate(0,-25%);

    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
`;

const ModalInnerCont = styled.div`
    position: relative;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
    &.modelInnerContCust:before {
        content: '';
        display: block;
        width: 40px;
        height: 4px;
        border-radius: 2px;
        background-color: #d8d8d8;
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        top: 4px;
        margin-bottom: 0px;
    }
    
    .filterType {
        list-style: none;
        margin-bottom:15px;
        li{
            float: none;
            margin: 0;
            em{
                float:none;
                margin-left: -5px;
                font-weight: normal;
            }
            input[type=radio]{
                width: 20px;
                height: 20px;
                margin: 0;
                position: relative;
                visibility: hidden;
                left: -20px;
                &:after{
                    content: '';
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    color: var(--green);
                    border: 2px solid black;    
                    visibility: visible;
                }
            }
            input[type=radio]:after{
                border-radius: 50%;
            }
            input[type=radio]:checked:before{
                content: '';
                background: #00a465;
                height: 11px;
                width: 11px;
                color: green;
                visibility: visible;
                position: absolute;
                border-radius: 50%;
                left: 4.5px;
                top: 4.5px;
            }
        }
        
    }
`;


interface PopupProps {
    title?: string,
    closable?: boolean,
    onClose: Function,
    style?: any;
    getSortDate: any,
}

const SortPopup: React.FC<PopupProps> = (props: PopupProps) => {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [applyDate, setApplyDate] = useState<any>();
    const [isSortChecked, setIsSortChecked] = useState(false);
    const { nfoAppliedSortItem } = propsToJS(useSelector(NFOSelector));

    useEffect(() => {
        nfoAppliedSortItem && setApplyDate(nfoAppliedSortItem);
    }, [nfoAppliedSortItem]);

    
    const applySort = () => {
        props?.onClose(false);
        props.getSortDate(applyDate);
        dispatch(setNFOappliedSortOption(applyDate));
    }
    const reset = () => {
        setApplyDate(false);
        props?.onClose(false);
        props.getSortDate(false);
        dispatch(setNFOappliedSortOption(false));
    }


    return (<PopupCont style={props.style}>
        <VerticleAlignedCont className={isMobile ? "mediaPopup" : ""}>
            <ModalOuterCont className={isMobile ? "w100" : "webModelWidth"} onClick={(e) => e.stopPropagation()}>
                <ModalInnerCont className={isMobile ? "modelInnerContCust" : ""}>
                    <div className="show p16">
                        <div className='filterHead'>
                            <h4>Sort By</h4>
                            <img onClick={() => props?.onClose(false)} src={closeIcon}/>
                        </div>
                        <div className='filterType'>
                            <span className="sortDate">Launch Date</span><div>
                                <div className='mt-10'>
                                    <CustomRadio
                                        value="launchEF"
                                        name='sortDate'
                                        onChange={() => setApplyDate('launchEF')}
                                        label={<span>Earliest First</span>}
                                        checked={applyDate === 'launchEF'}
                                    />
                                </div>
                                <div className='mt-10'>
                                    <CustomRadio
                                        value="launchFF"
                                        name='sortDate'
                                        onChange={() => setApplyDate('launchFF')}
                                        label={<span>Farthest First</span>}
                                        checked={applyDate === 'launchFF'}
                                     />
                                </div>
                           
                            <br />
                            <span className="sortDate">Closing Date</span>
                            <div className='mt-10'>
                                <CustomRadio
                                    value="closeEF"
                                    name='sortDate'
                                    onChange={() => setApplyDate('closeEF')}
                                    label={<span>Earliest First</span>}
                                    checked={applyDate === 'closeEF'}

                                />
                            </div>
                            <div className='mt-10'>
                                <CustomRadio
                                    value="closeFF"
                                    name='sortDate'
                                    onChange={() => setApplyDate('closeFF')}
                                    label={<span>Farthest First</span>}
                                    checked={applyDate === 'closeFF'}

                                />
                            </div>
                            </div>
                        </div>
                        <div className="mint-flex">
                            <button className="greenBorderBox nfoApplyBtn" onClick={reset}><img src={resetIcon} alt="restIcon" /> Reset</button>
                            <button className="greenBtn nfoApplyBtn" onClick={applySort} disabled={isSortChecked}> Apply</button>
                        </div>
                        
                    </div>
                </ModalInnerCont>
            </ModalOuterCont>
        </VerticleAlignedCont>
    </PopupCont>)
}

SortPopup.defaultProps = {
    closable: true
}

export default SortPopup;